import React from "react";

/** Ported verbatim from the legacy widget's /legal/privacy page. This is legal
    copy — reword nothing without sign-off. */
function PrivacyContent() {
  return (
    <>
      <h1>Apointa Privacy & Cookie Policy</h1>

      <h2>Privacy Policy</h2>
      <p>
        At Apointa, we take your privacy seriously. This Privacy & Cookie Policy explains how we collect, use, and protect your personal information
        when you use our platform.
      </p>

      <h3>Information We Collect</h3>
      <p>We collect information that you provide directly to us, including:</p>
      <ul>
        <li>Name, email address, phone number</li>
        <li>Payment information</li>
        <li>Booking preferences and history</li>
        <li>Account credentials</li>
        <li>Communications with us</li>
      </ul>

      <h3>How We Use Your Information</h3>
      <p>We use your information to:</p>
      <ul>
        <li>Process your bookings and payments</li>
        <li>Communicate with you about your bookings</li>
        <li>Improve our services and platform</li>
        <li>Send you important updates and marketing communications (with your consent)</li>
        <li>Comply with legal obligations</li>
      </ul>

      <h3>Information Sharing</h3>
      <p>We share your information with:</p>
      <ul>
        <li>Sports facilities and coaches (Partners) to fulfill your bookings</li>
        <li>Payment processors to handle transactions</li>
        <li>Service providers who assist in operating our platform</li>
        <li>Legal authorities when required by law</li>
      </ul>

      <h3>Data Security</h3>
      <p>
        We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet is 100%
        secure, and we cannot guarantee absolute security.
      </p>
      <p>
        All credit/debit cards' details and personally identifiable information will NOT be stored, sold, shared, rented or leased to any third
        parties.
      </p>
      <p>http://widget.apointa.com/ will not pass any debit/credit card details to third parties.</p>

      <h3>Your Rights</h3>
      <p>You have the right to:</p>
      <ul>
        <li>Access your personal information</li>
        <li>Correct inaccurate information</li>
        <li>Request deletion of your information</li>
        <li>Opt-out of marketing communications</li>
        <li>Withdraw consent for data processing</li>
      </ul>

      <h2>Cookie Policy</h2>
      <p>
        We use cookies and similar technologies to enhance your experience on our platform. This section explains how we use these technologies and
        how you can manage your preferences.
      </p>

      <h3>What Are Cookies?</h3>
      <p>
        Cookies are small text files stored on your device when you visit our website. They help us remember your preferences and improve your
        browsing experience.
      </p>

      <h3>Types of Cookies We Use</h3>
      <ul>
        <li>
          <strong>Essential Cookies:</strong> Required for the website to function properly. They enable basic functions like page navigation and
          access to secure areas.
        </li>
        <li>
          <strong>Functional Cookies:</strong> Remember your preferences and settings to enhance your experience.
        </li>
        <li>
          <strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website by collecting anonymous information.
        </li>
        <li>
          <strong>Marketing Cookies:</strong> Track your browsing habits to deliver relevant advertising.
        </li>
      </ul>

      <h3>Managing Cookies</h3>
      <p>
        You can control and/or delete cookies as you wish. You can delete all cookies that are already on your computer and you can set most browsers
        to prevent them from being placed. However, if you do this, you may have to manually adjust some preferences every time you visit our site and
        some services and functionalities may not work.
      </p>

      <h3>Third-Party Cookies</h3>
      <p>
        Some cookies are placed by third-party services that appear on our pages. We have no control over these cookies and they are subject to the
        privacy policies of the respective third parties.
      </p>

      <h3>Updates to This Policy</h3>
      <p>
        We may update this Privacy & Cookie Policy from time to time. We will notify you of any changes by posting the new policy on this page and
        updating the "Last Updated" date.
      </p>

      <h3>Contact Us</h3>
      <p>If you have any questions about this Privacy & Cookie Policy, please contact us at:</p>
      <p>
        Apointa (FZC)
        <br />
        info@apointa.com
        <br />
        M: +971 50 732 7832
        <br />
        Apointa (FZC), registered in Sharjah Research Technology and Innovation Park, Block C VL10-049, Sharjah, UAE
      </p>
    </>
  );
}

export default PrivacyContent;
